import styled, { css, keyframes } from 'styled-components'
import { Devices, Spacings, Text } from '@styles'
import { Button, H5, H6, SectionHeader } from '@base'
import { GSTCard } from '@pages/Admin/OrgsAndUsers/Organisation/styles'

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100%;
	min-width: 100%;
`

export const BaseWrapper = styled.div`
	padding: 0 ${Spacings.SPACING_4B};
	background: ${({ theme }) => theme.palette.background.white};
	box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);
	@media ${Devices.tablet} {
		border-radius: ${Spacings.SPACING_2B};
		margin-bottom: ${Spacings.SPACING_4B};
	}
`

export const CreateEnquiryWrapper = styled(BaseWrapper)`
	flex-grow: 1;
	display: flex;
	flex-direction: column;
`

export const PsuedoWrapper = styled.div`
	position: sticky;
	bottom: 0;
	z-index: 1;
	background: ${({ theme }) => theme.palette.background.searchgrey};
	border-top: 1px solid ${({ theme }) => theme.palette.background.searchgrey};

	@media ${Devices.tablet} {
		margin: 0 -${Spacings.SPACING_4B};
	}
`

export const CreateEnquiryFooter = styled.div`
	background: ${({ theme }) => theme.palette.background.white};
	box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);
	display: flex;
	flex-direction: column;

	position: relative;
`

export const ButtonsWrapper = styled.div`
	display: flex;
	margin: ${Spacings.SPACING_3B} ${Spacings.SPACING_4B};
`

export const PaddedWrapper = styled.div`
	padding: ${Spacings.SPACING_2B} 0;
`

export const PillsWrapper = styled.div`
	padding-top: ${Spacings.SPACING_4B};
`

export const StepWrapper = styled(PaddedWrapper)``
export const SectionBody = styled.div`
	display: flex;
`
export const ItemsWrapper = styled.div`
	flex-grow: 1;
`

export const ItemWrapper = styled.div`
	flex-grow: 1;
	margin-bottom: ${Spacings.SPACING_5B};
`
export const QuotePickerWrapper = styled.div`
	display: flex;
	padding: ${Spacings.SPACING_1B} ${Spacings.SPACING_4B} ${Spacings.SPACING_2B};
	flex-wrap: wrap;
`

export const ScrapQuoteItemWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	margin-right: ${Spacings.SPACING_4B};
	& > div {
		width: 100%;

		&:first-of-type {
			margin-right: ${Spacings.SPACING_4B};
		}
	}

	@media ${Devices.tablet} {
		flex-direction: row;
	}
`
export const QuoteItemWrapper = styled.div`
	width: calc(50% - 0.5rem);
	&:first-of-type {
		flex-grow: 1;
		width: 100%;
	}

	&:nth-of-type(2) {
		margin-right: ${Spacings.SPACING_4B};
	}

	@media ${Devices.tablet} {
		width: initial;
		&:first-of-type {
			width: initial;
		}
		flex-grow: 1;
		margin-right: ${Spacings.SPACING_4B};
		&:last-of-type {
			margin-right: 0;
		}
	}
`
export const ActionButton = styled(Button)``

export const BackButton = styled(Button)`
& > svg {
    margin-right ${Spacings.SPACING_1B};
}
`

export const bounce = keyframes`
0% {
    padding-bottom: 0;
}
20% {
    padding-bottom: 4px;
}
30% {
    padding-bottom: 8px;
}
40% {
    padding-bottom: 12px;
}
50% {
    padding-bottom: 16px;
}
60% {
    padding-bottom: 12px;
}
70% {
    padding-bottom: 8px;
}
80% {
    padding-bottom: 4px;
}
100% {
    padding-bottom: 0;
}

`

export const MobileAmountSection = styled.div`
	background: ${({ theme }) => theme.palette.background.white};
	box-shadow: 0 ${Spacings.SPACING_1B} ${Spacings.SPACING_5B} 0 rgb(0 0 0 / 5%);

	@media ${Devices.tablet} {
		display: none;
	}
`
export const DesktopAmountSection = styled.div`
	display: none;
	@media ${Devices.tablet} {
		display: initial;
		min-width: 17rem;
		width: 17rem;
		margin-left: ${Spacings.SPACING_6B};
		border-radius: ${Spacings.SPACING_2B};
		height: fit-content;
	}
`

export const TotalAmountSection = styled.div`
	padding: ${Spacings.SPACING_3B};
	display: flex;
	user-select: none;
	border-bottom: 1px solid ${({ theme }) => theme.palette.background.searchgrey};

	@media ${Devices.tablet} {
		padding: 0 0 ${Spacings.SPACING_4B} 0;
	}
`
export const InfoPanel = styled.div`
	min-height: ${({ show }) => (show ? '18rem' : '0')};
	max-height: ${({ show }) => (show ? '28rem' : '0')};
	border-bottom: 1px solid ${({ show, theme }) => (show ? theme.palette.background.searchgrey : theme.palette.background.white)};

	transition: all 0.15s ease-in-out;
	overflow-y: scroll;

	/* Hide scrollbar for Chrome, Safari and Opera */
	&::-webkit-scrollbar {
		display: none;
	}
	/* Hide scrollbar for IE, Edge and Firefox */
	& {
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
	}

	padding: ${({ show }) => (show ? `${Spacings.SPACING_4B} ${Spacings.SPACING_3B}` : `0 ${Spacings.SPACING_3B}`)};

	${({ amountPanelAnimation }) => {
		if (amountPanelAnimation) {
			return css`
				animation-name: ${bounce};
				animation-duration: 0.8s;
				animation-iteration-count: infinite;
				animation-timing-function: ease-in;
				animation-fill-mode: forwards;
			`
		}
	}}

	@media ${Devices.tablet} {
		min-height: fit-content;
		max-height: fit-content;
		padding: ${Spacings.SPACING_4B} 0;
		border: none;
		animation: none;
	}
`

export const Label = styled.span`
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.label};
	display: inline-block;
	margin-bottom: ${Spacings.SPACING_2B};
`

export const FlexWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

export const PartialAmountWrapper = styled(FlexWrapper)`
	padding: ${Spacings.SPACING_2B};
	border-radius: ${Spacings.SPACING_2B};
	background: ${({ theme }) => theme.palette.background.pill};
	margin-top: ${({ margin }) => margin || Spacings.SPACING_2B};
`

export const TotalAmountWrapper = styled(FlexWrapper)`
	align-items: flex-end;
	margin-left: auto;
`

export const IconWrapper = styled(FlexWrapper)`
	align-items: center;
	justify-content: center;
	padding: ${Spacings.SPACING_2B} 0 ${Spacings.SPACING_2B} ${Spacings.SPACING_2B};
	margin-left: ${Spacings.SPACING_3B};
	border-left: 1px solid ${({ theme }) => theme.palette.background.searchgrey};
	cursor: pointer;
`

export const Amount = styled.span`
	display: flex;
	flex-wrap: wrap;
	font-weight: ${Text.BOLD_600};
	line-height: ${Text.LINE_HEIGHT_MAX};
`
export const CardSpan = styled(H6)`
	line-height: ${Text.LINE_HEIGHT_MAX};
	margin: ${Spacings.SPACING_1B} 0px 0px ${Spacings.SPACING_1B};
	font-size: ${Text.EXTRA_SMALL};
`

export const Sign = styled.div`
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_600};
	margin-top: ${Spacings.SPACING_2B};
	text-align: center;
`

export const Heading = styled(H5)`
	@media ${Devices.tablet} {
		margin-bottom: ${Spacings.SPACING_3B};
	}
`

export const SingleItemWrapper = styled.div`
	max-width: ${({ isMaxWidth }) => (isMaxWidth ? '' : '20rem')};
	padding-top: ${Spacings.SPACING_1B};
`

export const SupplierSelectWrapper = styled.div`
	width: 100%;

	@media ${Devices.tablet} {
		width: 50%;
		display: flex;
		gap: ${Spacings.SPACING_2B};
		& > div {
			flex: 7;
		}
		& > div:nth-child(3) {
			flex: 5;
		}
	}
`

export const DetailsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_4B};
	@media ${Devices.tablet} {
		flex-direction: row;
	}
	& > div {
		width: 100%;
		@media ${Devices.tablet} {
			width: 50%;
		}
	}
	@media ${Devices.tablet} {
	}
`

export const PaymentTermsHeaader = styled(SectionHeader)`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	& > button {
		min-height: 0;
		height: fit-content;
		min-width: 0;
		width: fit-content;
	}
	margin-top: ${({ PaddedHeading }) => PaddedHeading && Spacings.SPACING_6B};
`

export const AddressMainWrapper = styled.div`
	display: flex;
	flex-direction: column;
	column-gap: ${Spacings.SPACING_2B};
	width: 100%;
	@media ${Devices.mobile} {
		flex-direction: column;
		column-gap:;
	}
	& > div {
		width: 100%;
	}
`

export const AddressCardWrapper = styled(GSTCard)`
	margin-bottom: ${Spacings.SPACING_2B};
	${({ noBackgroundColor }) => {
		if (noBackgroundColor) {
			return css`
				background: none;
			`
		}
	}}
`